import React, { useState, useEffect } from 'react';
import './Navbar.css'; // Import the CSS file for styles
import logo from '../../assets/logo.png'

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState({});
  const [navbarBg, setNavbarBg] = useState(false); // State for navbar background
  const [logoVisible, setLogoVisible] = useState(true);

  const toggleDropdown = (item) => {
    setIsDropdownOpen((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleScroll = () => {
    // Check if the user has scrolled up by a certain amount
    const scrollThreshold = window.innerHeight * 0.25; // 25% of viewport height

    if (window.scrollY > scrollThreshold) {
      setLogoVisible(false);
      setNavbarBg(true);
    } else {
      setLogoVisible(true);
      setNavbarBg(false);
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll); // Add scroll event listener

    return () => {
      document.removeEventListener('scroll', handleScroll); // Cleanup
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll('.dropdown-content');
      dropdowns.forEach((dropdown) => {
        if (dropdown && !dropdown.contains(event.target)) {
          setIsDropdownOpen({});
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header
      className={`fixed w-full top-0 left-0 z-50 p-1 transition-all duration-300 ${
        navbarBg
          ? "bg-transparent"
          : "bg-transparent"
      }`}
    >
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        <div className="flex items-center space-x-2">
          <i className="fas fa-plane-departure fa-spin text-white text-2xl"></i>
          {/* <h1 className="text-white text-2xl font-cursive">TravelMe</h1> */}
          {logoVisible && <img src= {logo} style={{height:'130px' , width:'150px'}} alt="Logo"/>}
        </div>

        <nav className="space-x-6 text-white hidden md:flex text-sm ml-auto">
         
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
